module.exports = "/fonts/Objectivity-Medium.woff2";